import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of, delay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserService } from './user';
import { mapWorkshopsFromApi, Workshop, WorkshopApiResponse } from '../models/workshop';

//#region Constants
const LOADING_DELAY = 500;
//#endregion

export interface GetWorkshopsRequest {
  startDate: string;  // ISO 8601 UTC — e.g. "2026-06-01T00:00:00.000Z"
  endDate: string;
  userId: number;
}

export interface CreateWorkshopRegistrationRequest {
  workshopSessionId: number;
  registeredUserId: number;
  status: string;
  preferredContact: string;
  zipCode: string;
  relatedCaseNumber: string;
  accessibilityNotes: string;
  notes: string;
  createdBy: number;
}


@Injectable({
  providedIn: 'root',
})
export class WorkshopService {
  private http = inject(HttpClient);
  private userService = inject(UserService);
  private baseUrl = `${environment.dashApiUrl}/api/Workshop`;

  getWorkshops(startDate: string, endDate: string): Observable<Workshop[]> {
    /*
     return of(MOCK_WORKSHOP_API_DATA).pipe(
       delay(LOADING_DELAY),
       map(mapWorkshopsFromApi)
     );
*/
    const user = this.userService.getUserInfoFromStorage();
    const payload: GetWorkshopsRequest = {
      startDate,
      endDate,
      userId: user?.userId ?? 0
    };
    return this.http.post<WorkshopApiResponse[]>(
      `${this.baseUrl}/getWorkshops`,
      payload
    ).pipe(map(mapWorkshopsFromApi));
  }

  getRegisteredWorkshops(): Observable<Workshop[]> {
    // TODO: Replace with dedicated endpoint when available — currently pulls full year range
    // and filters client-side.
    const now = new Date();
    const startDate = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()).toISOString();
    const endDate = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate()).toISOString();
/*
     return of(MOCK_WORKSHOP_API_DATA).pipe(
       delay(LOADING_DELAY),
       map(mapWorkshopsFromApi),
     map(workshops => workshops.filter(w => w.isRegistered))
     );
*/

    const user = this.userService.getUserInfoFromStorage();
    const payload: GetWorkshopsRequest = { startDate, endDate, userId: user?.userId ?? 0 };
    return this.http.post<WorkshopApiResponse[]>(
      `${this.baseUrl}/getWorkshops`,
      payload
    ).pipe(
      map(mapWorkshopsFromApi),
      map(workshops => workshops.filter(w => w.isRegistered))
    );
  }

register(workshopSessionId: number, accessibilityNotes?: string): Observable<void> {
  const user = this.userService.getUserInfoFromStorage();
  //console.log('Registering for session: ' + workshopSessionId + ' userId: ' + user?.userId);
  const payload: CreateWorkshopRegistrationRequest = {
    workshopSessionId,
    registeredUserId: user?.userId ?? 0,
    createdBy: user?.userId ?? 0,
    status: 'Registered',
    preferredContact: '',
    zipCode: '',
    relatedCaseNumber: '',
    accessibilityNotes: accessibilityNotes ?? '',
    notes: '',
  };
  return this.http.post<void>(
    `${this.baseUrl}/createRegistration`,
    payload
  );
}

  cancel(workshopRegistrationId: number): Observable<void> {
    // TODO: confirm cancel endpoint structure 
    return this.http.patch<void>(
      `${this.baseUrl}/cancelRegistration`,
      { workshopRegistrationId }
    );
  }
}
